<template>
  <v-container fill-height>
    <v-row :class="$vuetify.breakpoint.name === 'xs' ? 'pa-3 align-center justify-center' : 'pa-16 align-center justify-center'" align="center" justify="center">
      <v-col cols="12" sm="10" md="8" lg="6" xl="6" :class="$vuetify.breakpoint.name === 'xs' ? 'primary darken-1 elevation-24' : 'primary darken-1 elevation-24 pa-8'" style="border-radius: 8px">
        <v-form ref="form" lazy-validation v-model="valid">
          <v-card-title class="mb-n6">
            <strong class="titleForm">
              Solicitar Acesso
            </strong>
          </v-card-title>
          <v-card-title>
            <span class="subtitleForm">
              Se você ainda não tem as credenciais para acessar o Infohidro preencha o formulário abaixo e aguarde a resposta por e-mail.
            </span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" align-self="start" align="start">
                <label :class="{'secondary--text':labelName}">Seu nome</label>
              </v-col>
              <v-col cols="12" class="mt-n5 ml-n0 mb-n7">
                <v-text-field
                  placeholder="Informe seu nome completo"
                  color="secondary"
                  id="name"
                  aria-label="nome"
                  v-model="name"
                  :rules="[nameRules]"
                  prepend-inner-icon="mdi-account-circle-outline"
                  outlined
                  required
                  @focus="focusFunction('name')"
                  @blur="blurFunction('name')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" align-self="start" align="start">
                <label :class="{'secondary--text':labelEmail}">Seu e-mail</label>
              </v-col>
              <v-col cols="12" class="mt-n5 ml-n0 mb-n7">
                <v-text-field
                  placeholder="Informe seu e-mail corporativo"
                  color="secondary"
                  id="email"
                  aria-label="email"
                  v-model="email"
                  :rules="[emailRules]"
                  prepend-inner-icon="mdi-email-outline"
                  outlined
                  required
                  @focus="focusFunction('email')"
                  @blur="blurFunction('email')"
                />
              </v-col>
              <v-col cols="12" align-self="start" align="start">
                <label :class="{'secondary--text':labelSector}">Seu setor</label>
              </v-col>
              <v-col cols="12" class="mt-n5 ml-n0">
                <v-select
                  placeholder="Selecione o setor que trabalha atualmente"
                  color="secondary"
                  v-model="sector"
                  id="sector"
                  aria-label="setor"
                  prepend-inner-icon="mdi-office-building"
                  :rules="[sectorRules]"
                  sector
                  :items="sectors"
                  single-line
                  outlined
                  required
                  @focus="focusFunction('sector')"
                  @blur="blurFunction('sector')"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <div v-show="alert">
            <v-alert text type="success">
              <span style="font-size: 1rem">Pedido enviado com sucesso, aguarde a resposta por e-mail.</span>
            </v-alert>
          </div>
          <div v-show="score">
            <v-alert text type="warning" icon="mdi-security">
              <span style="font-size: 1rem">Desculpe. Não foi possível realizar a validação de segurança, por favor tente novamente.</span>
            </v-alert>
          </div>
          <v-card-actions class="ml-2">
            <v-btn
              style="border-radius: 8px; padding: 16px 24px; width: 92px;height: 52px;"
              color="secondary lighten-1"
              @click="solicitation"
              :loading="loading"
              :disabled="!valid"
            >
              <span style="font-size: 1rem">Enviar</span>
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import {accessRequestInfohidro} from "@/api/prognozweb/email.api";

export default {
  name: "SolicitationForm",
  data(){
    return{
      name: '',
      email: '',
      sector: '',
      sectors: [
        'GGND - Gerência Geral Região Nordeste',
        'GGNO - Gerência Geral Região Noroeste',
        'GGSO - Gerência Geral Região Sudoeste',
        'GPAG - Gerência do Processo Água',
        'GPDAG - Gerência de Produção da Água',
      ],
      loading: false,
      alert: false,
      score: false,
      labelEmail: false,
      labelName: false,
      labelSector: false,
      valid: false,
    }
  },
  computed:{
    sectorRules(){
      if(!this.sector){
        return 'Você precisa selecionar um setor para solicitar o acesso ao Infohidro.';
      }
      return true;
    },
    emailRules(){
      if(!this.email){
        return 'Você precisa inserir seu e-mail para solicitar o acesso ao Infohidro.';
      }
      if(/.+@.+\..+/.test(this.email) == false){
        return 'Este e-mail é inválido.';
      }
      let domain = this.email.split('@')
      if(domain){
        if ( !domain[1].includes('sanepar.com.br') && !domain[1].includes('simepar.br') ) {
          return 'Você precisa inserir um e-mail corporativo da Sanepar ou Simepar'
        }
      }
      return true;
    },
    nameRules(){
      if(!this.name){
        return 'Você precisa inserir seu nome para solicitar o acesso ao Infohidro.';
      }
      if(/^[A-Za-zàáãäâèéëêìíïîòóõöôùúüûçÀÁÃÄ ÈÉËÊÌÍÏÎÒÓÕÖÔÙÚÜÛÇ ]+$/.test(this.name) == false){
        return 'Este nome é inválido.';
      }
      return true;
    },
  },
  methods:{
    async recaptcha() {
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('login')
      await this.$store.dispatch("googleRecaptchaResponse", {token: token} )
      let response = await this.$store.getters.recaptcha
      if(response){
        if(response.success === true && response.score > 0.5){
          return true
        } else {
          this.score = true
          setTimeout(() => { this.score = false ; this.reset() }, 6000)
          return false
        }
      }
    },
    async solicitation () {
      if ( this.$refs.form.validate() && await this.recaptcha() ) {
        this.loading = true

        this.valid = true;

        // await accessRequestInfohidro({ object });
        await this.$store.dispatch("submitAccessRequestInfohidro", {
          name: this.name,
          email: this.email,
          sector:  this.sector,
        });

        this.loading = false;
        this.alert = true;
        this.valid = false;
        this.reset();
      }
    },
    reset() {
      setTimeout(() => {
        this.alert = false;
        this.valid = false;
        this.$refs.form.reset();
      }, 4000);
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    focusFunction(val){
      if(val === 'email'){
        this.labelEmail = true
      } else if(val === 'name'){
        this.labelName = true
      } else { this.labelSector = true }
    },
    blurFunction(val){
      if(val === 'email'){
        this.labelEmail = false
      } else if(val === 'name'){
        this.labelName = false
      } else { this.labelSector = false }
    }
  }
}
</script>

<style scoped>
.subtitleForm {
  font-family: "Poppins", sans-serif !important;
  font-style: normal;
  font-weight: 300;
  font-size: 0.875rem;
  line-height: 21px;
  word-break: break-word;
}

.titleForm {
  font-family: "Questrial", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 2rem;
  line-height: 33px;
}
.v-btn{
  text-transform: none;
}
label{
  color: #ffffff;
}
</style>
